import { Node } from '@react-types/shared';
import React, { useRef } from 'react';
import { useMenuItem } from 'react-aria';
import { TreeState } from 'react-stately';
import { MenuListItem } from 'components/MenuList';
import { ItemProps } from '../Item';

export interface MenuItemProps<T> {
  item: Omit<Node<T>, 'props'> & { props?: ItemProps<T> };
  state: TreeState<T>;
}

/**
 * Standard menu item that fire's a callback from `Menu` when clicked
 */
export function MenuItem<T>({
  item,
  state,
}: MenuItemProps<T>): React.ReactElement | null {
  const ref = useRef<HTMLLIElement>(null);
  const { menuItemProps, isDisabled, isFocused } = useMenuItem(
    { key: item.key },
    state,
    ref,
  );

  const { icon } = item?.props ?? {};

  return (
    <MenuListItem
      {...menuItemProps}
      {...{ isDisabled, isFocused, icon }}
      ref={ref}
    >
      {item.rendered}
    </MenuListItem>
  );
}

export default MenuItem;
